import React from 'react'
import './SummaryReport.scss'
import PropTypes from 'prop-types'
import { ReactComponent as SummaryLogo } from '@src/assets/summary_right_logo.svg'
import Comps from '@engine/comps'
import { connect } from 'react-redux'
import { formatNumber } from '@engine/utils/format'
import { EditButtonWrapper } from '@components/common'
import { EditPropertyDetails } from '../EditPropertyDetails/EditPropertyDetails'
import {
  SALES_COMPARABLES,
  RENT_COMPARABLES,
  propertySummaryRent,
  propertySummarySales,
  propertySummaryStudentHousing
} from '@engine/dependencies/constants'
export class SummaryReport extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isDialogOpen: false
    }
  }

  formatValue(col, value) {
    if (col.value === 'propertyAddress' && (this.props.compsWithSubjectProperty && !value)) {
      return ''
    }
    if (col.key === 'State' && value === undefined) {
      return 'NA'
    }
    if (this.props.templateName === 'studentHousingComps' || this.props.templateName.includes('rentComps')) {
      const { sourceNotesCount } = this.props.templateDataLimits
      if (col.value === 'notes' && col.key === 'Notes') {
        const trimmedNotes = value.trim()

        return trimmedNotes.length >= sourceNotesCount ? trimmedNotes.substring(0, sourceNotesCount) : trimmedNotes
      }
    }
    const result = formatNumber(col.value, value)
    if (!this.props.compsWithSubjectProperty && (col.value === 'propertyAddress' && !value)) {
      return ''
    }

    return result
  }

  handleDoneDialog = data => {
    this.props.editPropertyDetails({ type: 'summary', data: data.propertyFields, disclaimerTextData: data.disclaimerTextData })
  }

  handleEditButtonClick = () => {
    this.setState({
      isDialogOpen: !this.state.isDialogOpen
    })
  }

  render() {
    const { summarydata, hasBranding, hasPageTitle, themeColors, templateName, summaryTableColumns, summaryDisclaimerText, isSubjectPropertyDeleted } = this.props
    const PAGE_HEADER_RENT = 'COMPARABLE RENTAL PROPERTIES SUMMARY'
    const PAGE_HEADER_SALES = 'COMPARABLE SALES PROPERTIES SUMMARY'
    const dialogProperties = templateName.includes(SALES_COMPARABLES) ? propertySummarySales : (templateName.includes(RENT_COMPARABLES) ? propertySummaryRent : propertySummaryStudentHousing)
    dialogProperties.propertyFields = summaryTableColumns
    const contentNote = 'Select none to hide labels. To change the column order, drag and drop a field'
    const dialogTitle = 'Property Summary'

    const columnsWithKeys = summaryTableColumns.filter(col => col.key !== 'NA')
    const columns_to_be_displayed = isSubjectPropertyDeleted ? columnsWithKeys.filter(col => col.key !== 'Distance') : columnsWithKeys
    columns_to_be_displayed.unshift({ key: '', value: 'propertyType' })

    const page_header = templateName.includes(SALES_COMPARABLES) ? PAGE_HEADER_SALES : PAGE_HEADER_RENT

    const cmp_props =
      summarydata &&
      summarydata.map(property => {
        const values = Object.keys(property).reduce((propObj, col) => {
          if (
            columns_to_be_displayed.some(
              colHeader => colHeader.value === col
            )
          ) {
            propObj[col] = property[col]
          }

          return propObj
        }, {})

        return values
      })

    const summaryTableLastRow = {
      propertyType: '',
      name: 'Total / Averages',
      city: '',
      propertyAddress: '',
      units: '',
      yearBuilt: '',
      yearRen: '',
      mostRecentSaleDate: '',
      grossRentMultiplier: '',
      state: ''
    }

    if (cmp_props && cmp_props.length > 2) {
      for (const key in summaryTableLastRow) {
        if (summaryTableLastRow.hasOwnProperty(key)) {
          cmp_props[cmp_props.length - 1][key] = summaryTableLastRow[key]
        }
      }
    }

    const subjectPropMarkerStyle = {
      backgroundColor: themeColors.summarySubjectBackgroundColor,
      color: themeColors.summarySubjectTextColor,
      borderColor: themeColors.summarySubjectBorderColor,
      // fontFamily: '\'Montserrat\', sans-serif',
      fontFamily: '\'DIN Pro Light\'',
      fontSize: '10px'
    }

    const subjectRowBackgroundStyle = {
      backgroundColor: themeColors.summaryRowBackgroundColor
    }

    const comparablePropMarkerStyle = {
      backgroundColor: themeColors.summaryComparableBackgroundColor,
      color: themeColors.summaryComparableTextColor,
      border: `1px solid ${themeColors.summaryComparableBorderColor}`,
      // fontFamily: '\'Montserrat\', sans-serif',
      fontFamily: '\'DIN Pro Light\'',
      fontWeight: '500',
      fontSize: '10px'
    }

    return (
      <>
        <div
          data-testid="summary-report"
          className={(hasPageTitle || hasBranding) ? 'summary-report-view' : 'no-margin-summary-report-view'}
          id="#property_summary"
        >
          {(hasPageTitle || hasBranding) && (
            <div className="summary-header">
              <span style={{ 'color': themeColors.globalColor }}>{hasPageTitle && page_header}</span>
              {hasBranding && (
                <SummaryLogo data-testid="logo-long" className="summary_logo" />
              )}
            </div>
          )}
          <div data-testid="summuary-table" className="summary-table">
            <EditButtonWrapper handleEditButtonClick={this.handleEditButtonClick} dataTestId="edit-summary-report-button">
              <table>
                <tbody>
                  <tr>
                    {columns_to_be_displayed.map((column, index) => (
                      <th key={index} className={column.key}>{column.key}</th>
                    ))}
                  </tr>
                  {cmp_props &&
                    cmp_props.map((row, i) => (
                      <tr key={i} style={row.propertyType.toString().includes('S') ? subjectRowBackgroundStyle : {}}>
                        {columns_to_be_displayed.map((col, j) => (
                          <td key={j}>
                            {col.value === 'propertyType' ? (
                              row.propertyType.toString().includes('S') ? (
                                <div className="tableindex_subject" style={subjectPropMarkerStyle}>
                                  {this.formatValue(col, row[col.value])}
                                </div>
                              ) : i === cmp_props.length - 1 ? (
                                <span>{this.formatValue(col, row[col.value])}</span>
                              ) : (
                                <div className="tableindex_value" style={comparablePropMarkerStyle}>
                                  {this.formatValue(col, row[col.value])}
                                </div>
                              )
                            ) : (
                              <span>{this.formatValue(col, row[col.value], i)}</span>
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                </tbody>
              </table>
              {summaryDisclaimerText?.showDisclaimer && (
                <div className="summary-disclaimer-text">{summaryDisclaimerText.disclaimerText}</div>
              )}
            </EditButtonWrapper>
          </div>
        </div >
        {this.state.isDialogOpen ? (
          <EditPropertyDetails
            isDialogOpen={this.state.isDialogOpen}
            closeEditPopup={this.handleEditButtonClick}
            doneDialog={this.handleDoneDialog}
            contentNote={contentNote}
            dialogTitle={dialogTitle}
            dialogProperties={dialogProperties}
            isDisclaimerNeeded={true}
            summaryDisclaimerText={summaryDisclaimerText}
          />
        ) : ''}
      </>
    )
  }
}

SummaryReport.propTypes = {
  hasBranding: PropTypes.bool,
  hasPageTitle: PropTypes.bool,
  summarydata: PropTypes.array,
  themeColors: PropTypes.object,
  templateName: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  summaryTableColumns: PropTypes.array,
  editPropertyDetails: PropTypes.func,
  summaryDisclaimerText: PropTypes.object,
  compsWithSubjectProperty: PropTypes.bool,
  isSubjectPropertyDeleted: PropTypes.bool,
  templateDataLimits: PropTypes.object
}

const mapStateToProps = state => ({
  themeColors: Comps.selectors.comps.themeColors(state),
  summaryTableColumns: Comps.selectors.comps.summaryTableColumns(state),
  summaryDisclaimerText: Comps.selectors.comps.summaryDisclaimerText(state),
  compsWithSubjectProperty: Comps.selectors.comps.compsWithSubjectProperty(state),
  isSubjectPropertyDeleted: Comps.selectors.comps.isSubjectPropertyDeleted(state),
  templateDataLimits: Comps.selectors.comps.templateDataLimits(state)
})

const mapDispatchToProps = {
  editPropertyDetails: Comps.actions.editPropertyDetails
}

export default connect(mapStateToProps, mapDispatchToProps)(SummaryReport)
